
import React from 'react';
import { Button } from '@/components/ui/button';

const Hero = () => {
  const phoneNumber = "6147728925";
  
  const handleCallAction = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <section id="home" className="relative pt-36 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-navy/95 to-navy/85 -z-10"></div>
      <div 
        className="absolute inset-0 bg-[url('/lovable-uploads/3ff4a5da-2735-4aa7-ac34-485658e80a97.png')] bg-cover bg-center mix-blend-overlay -z-20"
        style={{ filter: 'brightness(0.7)' }}
      ></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto md:mx-0">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in font-serif">
            Discreet <span className="text-gold">Luxury Home</span> Cleaning Services
          </h1>
          
          <p className="text-lg text-white/90 mb-8 max-w-xl animate-fade-in font-sans leading-relaxed" style={{ animationDelay: "0.2s" }}>
            Impeccable cleaning tailored for discerning homeowners who expect nothing less than excellence, confidentiality, and flawless attention to detail from Gold Standard Cleaning Group.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <Button size="lg" className="bg-gold hover:bg-gold/90 text-navy font-medium" asChild>
              <a href="#services">
                View Our Bespoke Offerings
              </a>
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white/10 bg-transparent"
              onClick={handleCallAction}
            >
              Schedule Your Private Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
